const TypeMap = {
    boolean: Boolean,
    number: Number,
    string: String,
    function: Function,
    bigint: undefined,
    symbol: undefined,
    object: undefined,
    undefined,
};
export function partialSchemaToFull(partialSchema, settings) {
    return Object.fromEntries(Object.entries(partialSchema).map(([key, value]) => {
        const type = 'action' in value ? Function : TypeMap[typeof settings[key]];
        if (!type && !value.type) {
            console.error(`Cannot get type of ${key} in your settings object`);
        }
        return [
            key,
            Object.assign({ key,
                type }, value),
        ];
    }));
}
//# sourceMappingURL=partialSchemaToFull.js.map